export function PageBreak() {
  return <div className="wb-page-break">next page</div>;
}
